import * as yup from 'yup';
import type { FormDefinition } from '@gov-design-system-ce/react-form-core';
import {
	getFormDefinition,
	useGovForm,
} from '@gov-design-system-ce/react-form-core';
import type { RegistrSVFormData } from './context.types';

export function FormDefinitionInstance(): FormDefinition<RegistrSVFormData> {
	const formSchema = yup
		.object({
			filterVehicleDetails: yup.object({
				vehicle: yup.boolean(),
				motor: yup.boolean(),
				dimensions: yup.boolean(),
				weight: yup.boolean(),
				chassis: yup.boolean(),
				noise: yup.boolean(),
				others: yup.boolean(),
				otherRecords: yup.boolean(),
			}),
			filterDocuments: yup.object({
				prehledRz: yup.boolean(),
				prehledTp: yup.boolean(),
				prehledOrv: yup.boolean(),
				vehicleStatus: yup.boolean(),
				relationshipToVehicle: yup.boolean(),
			}),
		})
		.required();

	const formMethods = useGovForm<RegistrSVFormData>({
		formSchema,
		defaultValues: {
			filterVehicleDetails: {
				vehicle: true,
				motor: false,
				dimensions: false,
				weight: false,
				chassis: false,
				noise: false,
				others: false,
			},
			filterDocuments: {
				prehledRz: true,
				prehledTp: false,
				prehledOrv: false,
				vehicleStatus: false,
			},
		},
	});

	return getFormDefinition({ formMethods, formSchema });
}
